import { ChangeEvent } from 'react';

import { Checkbox } from '~/components/Checkbox';
import { CollapsibleV2 } from '~/components/CollapsibleV2';
import { ProductPropertyFilterChoice } from '~/types/Product/interface';

interface Props {
  label: string;
  values?: ProductPropertyFilterChoice[];
  currentValues?: string[];
  onChange: (values: string[]) => void;
  className?: string;
  innerClassName?: string;
  bodyContainerClassName?: string;
  isCollapsed: boolean;
  noCollapsible?: boolean;
}

const ProductTypeListFilter = ({
  label,
  values = [],
  currentValues = [],
  onChange,
  className,
  innerClassName,
  bodyContainerClassName,
  isCollapsed,
  noCollapsible,
}: Props) => {
  const onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    const newSelected = isChecked
      ? [...currentValues, value]
      : currentValues.filter((s) => s !== value);
    onChange(newSelected);
  };

  const filters = (
    <>
      {values.map((value, idx) => (
        <Checkbox
          key={`${value.value}_${idx}`}
          checked={currentValues.includes(value.value)}
          value={value.value}
          onChange={(e) => onChangeValue(e)}
          label={value.label}
        />
      ))}
    </>
  );

  if (noCollapsible) {
    return filters;
  }

  return (
    <CollapsibleV2
      isCollapsed={!currentValues.length && isCollapsed}
      title={label}
      className={className}
      innerClassName={innerClassName}
      bodyContainerClassName={bodyContainerClassName}
    >
      {filters}
    </CollapsibleV2>
  );
};

export default ProductTypeListFilter;
